import { useState } from 'react'

import { Box, Icon, Text } from '@factorialco/deprecated-design-system'
import { startCase } from 'lodash'

import PopoverMenu from 'modules/core/components/PopoverMenu'
import i18n from 'modules/core/lib/i18n'

import type { Policies } from 'modules/payroll_bundle/store/collections/policies'
import type Policy from 'modules/payroll_bundle/store/models/Policy'

import PolicySelectorPopoverContent from './PolicySelectorPopoverContent'

interface Props {
  policies: Policies
  selectedPolicy: Policy
  onPolicyChange: (policyId: string) => void
}

export default function PolicDropdownSelector({ policies, selectedPolicy, onPolicyChange }: Props) {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false)

  function handlePopoverToggle(newPopoverState: boolean) {
    setIsPopoverOpen(newPopoverState)
  }

  return (
    <Box aria-label={i18n.t('payroll_bundle.accessibility.payroll_policy_selector')}>
      {/* TODO: Refactor this kind of selector into a reusable component */}
      <PopoverMenu open={isPopoverOpen} type="list" onClick={handlePopoverToggle}>
        <PopoverMenu.Trigger>
          <Box
            paddingLeft="s12"
            paddingRight="s8"
            paddingY="s4"
            flexDirection="row"
            alignItems="center"
            gap="s8"
            style={{
              opacity: '1',
              cursor: 'pointer',
            }}
            borderRadius={{ all: 'abs008' }}
            border={{
              all: {
                width: 's2',
                style: 'solid',
                color: 'grey400',
              },
            }}
          >
            <Icon.Small icon="office" />
            <Text.Normal>
              {i18n.t('payroll_bundle.payroll_policy.name', {
                policyName: startCase(selectedPolicy.attributes.name),
              })}
            </Text.Normal>
            <Icon.Medium icon="chevron-down" />
          </Box>
        </PopoverMenu.Trigger>
        <PopoverMenu.Content side="bottom" align="start" width="s360">
          <PolicySelectorPopoverContent
            policies={policies}
            selectedPolicyId={selectedPolicy.id}
            onChange={(value) => {
              onPolicyChange(value)
              setIsPopoverOpen(false)
            }}
          />
        </PopoverMenu.Content>
      </PopoverMenu>
    </Box>
  )
}
